//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    inheritAttrs: false,

    props: {
        value: true,
        label: String,
        readonly: Boolean,
        placeholder: true,
        error: Boolean,
        hint: String,
        counter: Boolean,
        maxChars: Number,
        bottom: Boolean,
        preIcon: String,
        postIcon: String,
        outlined: Boolean,
    },

    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        bindables() {
            return {
                dense: true,
                label: this.label,
                readonly: this.readonly,
                placeholder: this.placeholder,
                error: this.error,
                hint: this.hint,
                counter: this.counter,
                maxChars: this.maxChars,
                bottom: this.bottom,
                preIcon: this.preIcon,
                postIcon: this.postIcon,
                outlined: this.outlined,
                ...this.$attrs,
            };
        },
    },
};
